export default __webpack_public_path__ + "img/1adc90fcb9de4c56cf9825b9fdc85884.png";